<template lang="pug">
  div
    .heading WHOIS Lookup
    .subtitle This page allows you to query WHOIS servers for information about ownership of a specified domain name or IP address.
    WHOISLookup
</template>
<script>
import WHOISLookup from "@/components/WHOISLookup";

export default {
  components: {
    WHOISLookup: WHOISLookup,
  },
};
</script>
